import React from "react";
import { useSiteContext } from "../../../../../context/SiteContext";
import { useEditCtaContext } from "../../../../../context/EditCtaContext";

const HorizontalTemplateOneOneThree = ({
  titleText = "Complete Growth Bundle",
  titleFont = "Poppins",
  titleFontSize = "26",
  titleColor = "#FFFFFF",
  titleTextAlign = "center",
  titleIsBold = false,
  titleIsItalic = false,
  titleIsUnderline = false,
  titleUppercase = false,
  titleLetterSpacing,

  secondarySubtitleText = "Save 25% today.",
  secondarySubtitleFont = "Poppins",
  secondarySubtitleFontSize = "28",
  secondarySubtitleColor = "#FFFFFF",
  secondarySubtitleTextAlign = "center",
  secondarySubtitleIsBold = false,
  secondarySubtitleIsItalic = false,
  secondarySubtitleIsUnderline = false,

  subtitleText = "Course access\nMentoring\nTemplates",
  subtitleFont = "Poppins",
  subtitleFontSize = "26",
  subtitleColor = "#FFFFFF",
  subtitleTextAlign = "left",
  subtitleIsBold = false,
  subtitleIsItalic = false,
  subtitleIsUnderline = false,

  buttonLabel = "Start Today",
  buttonFont = "Poppins",
  buttonIsBold = false,
  buttonIsItalic = false,
  buttonIsUnderline = false,
  buttonLink = "",
  buttonFontSize = "16",
  buttonFontColor = "#FFFFFF",
  buttonBackgroundColor = "#6B1B6B",

  backgroundType = "color",
  backgroundColor = "#8B88D8",
  backgroundImage = null,
  backgroundImagePreview,

  contentImageOne = null,
  contentImageOnePreview = null,

  inmeeting = false,
  position = null,
  preview = false,
  onClose,
}) => {
  if (
    (backgroundImage && ![null, "null"].includes(backgroundImage)) ||
    backgroundImagePreview
  )
    backgroundColor = "";
  const { meetingRole, setActiveElement } = useSiteContext();
  const { explicitBoleanCheck } = useEditCtaContext();

  return (
    <div
      className={`relative ${
        !inmeeting
          ? "h-auto"
          : ["top", "bottom"].includes(position)
          ? "h-[150px]"
          : "!h-[89vh] mt-[5%]"
      } w-full flex flex-row mx-auto items-center px-4 md:px-8 overflow-hidden`}
      style={{ backgroundColor }}
    >
      {/* Close Button */}
      {inmeeting && meetingRole === "moderator" && (
        <button
          className="absolute top-2 right-2 z-20 bg-red-500 hover:bg-red-600 text-white rounded-full w-6 h-6 flex items-center justify-center transition-colors"
          title="Close Banner"
          style={{ right: "8px", top: "8px" }}
          onClick={() => {
            if (meetingRole === "moderator") {
              onClose();
            } else {
              setActiveElement(null);
            }
          }}
        >
          <svg
            className="w-3 h-3"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        </button>
      )}

      {/* Background Image */}
      {(backgroundImage || backgroundImagePreview) && (
        <div
          className="absolute inset-0 w-full h-full opacity-90"
          style={{
            backgroundImage: `url(${
              backgroundImage instanceof File
                ? backgroundImagePreview
                : backgroundImage
            })`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
          }}
        />
      )}

      {/* Content Container */}
      <div className="relative z-10 flex flex-row justify-between items-center w-full max-w-7xl mx-auto gap-4 md:gap-8">
        {/* Left Section - Title and Subtitle Stacked */}
        <div className="flex flex-col flex-shrink-0">
          {/* Main Heading */}
          <h1
            className={`leading-none ${
              explicitBoleanCheck(titleIsBold) ? "font-bold" : ""
            } ${explicitBoleanCheck(titleIsItalic) ? "italic" : ""} ${
              explicitBoleanCheck(titleIsUnderline) ? "underline" : ""
            }`}
            style={{
              color: titleColor,
              fontSize: `${titleFontSize}px`,
              fontFamily: titleFont || "Helvetica",
              textAlign: titleTextAlign || "left",
              textTransform: titleUppercase ? "uppercase" : "none",
              ...(titleLetterSpacing
                ? { letterSpacing: titleLetterSpacing }
                : {}),
              whiteSpace: "pre-line",
            }}
          >
            {titleText}
          </h1>
        </div>

        {/* Middle Section - Content Image */}
        <div className="flex-1 flex items-center justify-center gap-4">
          {/* Subtitle List */}
          {subtitleText && (
            <div
              className={`leading-relaxed mt-2 ${
                explicitBoleanCheck(subtitleIsBold) ? "font-bold" : ""
              } ${explicitBoleanCheck(subtitleIsItalic) ? "italic" : ""} ${
                explicitBoleanCheck(subtitleIsUnderline) ? "underline" : ""
              }`}
              style={{
                fontSize: `${subtitleFontSize}px`,
                color: subtitleColor,
                textAlign: subtitleTextAlign || "left",
                fontFamily: subtitleFont || "Helvetica",
                whiteSpace: "pre-line",
              }}
            >
              {subtitleText}
            </div>
          )}
          {contentImageOne || contentImageOnePreview ? (
            <img
              src={
                contentImageOne instanceof File
                  ? contentImageOnePreview
                  : contentImageOne
              }
              alt="Product"
              className="h-full max-h-[200px] w-auto object-contain"
            />
          ) : (
            <img
              src="/image_placeholder.png"
              alt="Product"
              className="h-full max-h-[200px] w-auto object-contain"
            />
          )}
          {/* Secondary Subtitle */}
          {secondarySubtitleText && (
            <p
              className={`${
                explicitBoleanCheck(secondarySubtitleIsBold) ? "font-bold" : ""
              } ${
                explicitBoleanCheck(secondarySubtitleIsItalic) ? "italic" : ""
              } ${
                explicitBoleanCheck(secondarySubtitleIsUnderline)
                  ? "underline"
                  : ""
              } whitespace-nowrap`}
              style={{
                color: secondarySubtitleColor,
                fontSize: `${secondarySubtitleFontSize}px`,
                fontFamily: secondarySubtitleFont || "Helvetica",
                textAlign: secondarySubtitleTextAlign || "left",
              }}
            >
              {secondarySubtitleText}
            </p>
          )}
        </div>

        {/* Right Section - Secondary Subtitle and Button */}
        <div className="flex flex-col md:flex-row items-center gap-3 md:gap-4 flex-shrink-0">
          {/* Button */}
          <button
            className={`px-2 py-2 md:px-4 md:py-2 rounded-full transition-all duration-200 shadow-lg hover:shadow-xl whitespace-nowrap ${
              explicitBoleanCheck(buttonIsBold) ? "font-bold" : ""
            } ${explicitBoleanCheck(buttonIsItalic) ? "italic" : ""} ${
              explicitBoleanCheck(buttonIsUnderline) ? "underline" : ""
            } ${buttonLink ? "cursor-pointer" : "cursor-default"}`}
            style={{
              backgroundColor: buttonBackgroundColor,
              color: buttonFontColor,
              fontSize: `${buttonFontSize}px`,
              fontFamily: buttonFont || "Poppins",
            }}
            onClick={() => {
              if (buttonLink) {
                window.open(buttonLink, "_blank");
              }
            }}
          >
            {buttonLabel}
          </button>
        </div>
      </div>
    </div>
  );
};

export default HorizontalTemplateOneOneThree;
